<template>
    <div class="container">
        <h1 class="title">
            Item usage
        </h1>
        <h2 class="subtitle">
            Finding methods that can be used to gain gold by using items that are already owned.
        </h2>

        <EconomicsWarning/>

        <b-tabs>
            <b-tab-item label="Search">
                <div class="panel-block">
                    <b-field label="Which item should be used as an ingredient?"
                             message="Accepts ids. TODO: Search interface for this">
                        <b-field>
                            <b-input placeholder="Ingredient ID"
                                     type="text"
                                     icon="pound"
                                     v-model="ingredientId"
                            />
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block">
                    <b-field label="How much of the ingredient should be considered?"
                             message="Do not use too high values or the computation time will be insanely long. TODO: Restrict.">
                        <b-field>
                            <b-numberinput
                                    placeholder="Ingredient Amount"
                                     type="text"
                                     v-model="ingredientAmount"
                            />
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block">
                    <b-field label="How to buy materials?"
                             message="Select the method that will be used to buy all materials that are best bought from the Trading Post.">
                        <b-field>
                            <b-radio-button v-model="buyType" native-value="instant">Instant buy</b-radio-button>
                            <b-radio-button v-model="buyType" native-value="buyorder">List buy orders</b-radio-button>
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block">
                    <b-field label="How to sell crafted items?"
                             message="Select the method that will be used to sell all products.">
                        <b-field>
                            <b-radio-button v-model="sellType" native-value="instant">Instant sell</b-radio-button>
                            <b-radio-button v-model="sellType" type="is-danger" native-value="sellorder"><b-icon icon="clock-outline"/>List sell orders</b-radio-button>
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block">
                    <b-field label="Allow time-gated recipes?"
                             message="Some time-gated recipes are very slow to calculate and you can typically only craft one a day.">
                        <b-field>
                            <b-radio-button v-model="timegated" :native-value="false">No</b-radio-button>
                            <b-radio-button v-model="timegated" type="is-warning" :native-value="true"><b-icon icon="clock-outline" />Yes</b-radio-button>
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block">
                    <b-field label="Allow splitting merchant recipes?"
                             message="TODO: Implement and explain.">
                        <b-field>
                            <b-radio-button disabled>No</b-radio-button>
                            <b-radio-button disabled>Yes</b-radio-button>
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block">
                    <b-field label="Currencies"
                             message="Allowed currencies. These will be spent in any amount in order to maximize gold profit.">
                        <b-field>
                            <b-checkbox-button :key="index" v-for="(currency, index) in availableCurrencies"
                                               v-model="currencies"
                                               :native-value="currency"
                                               :disabled="currency === 'Coppers'"
                            >
                                <img class="image is-24x24" :src="currencyIcons[currency]" :alt="currency">
                                {{currency === 'Coppers' ? 'Gold' : currency}}
                            </b-checkbox-button>
                        </b-field>
                    </b-field>
                </div>
                <div class="panel-block is-vertical">
                    <b-button type="is-primary" @click="clickCalculate" :disabled="!allowed || loading">
                        Calculate
                    </b-button>
                </div>
            </b-tab-item>
            <b-tab-item label="Results" :disabled="!loading && acquisition === null">
                <AcquisitionCard :acquisition.sync="acquisition" />
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import axios from 'axios'
    import AcquisitionCard from "@/components/AcquisitionCard";
    import EconomicsWarning from "@/components/EconomicsWarning";
    import Currencies from "@/currencies"


    export default {
        name: "ItemUsage.vue",
        components: {
            EconomicsWarning,
            AcquisitionCard
        },
        data() {
            return {
                acquisition: null,
                loading: false,
                loaded: false,
                error: "",
                ingredientId: "",
                ingredientAmount: 1,
                buyType: 'instant',
                sellType: 'instant',
                timegated: false,
                currencyIcons: Currencies.currencyIcons,
                availableCurrencies: Currencies.availableCurrencies,
                currencies: ["Coppers"]
            }
        },
        computed: {
            allowed() {
                return this.$store.state.permissions.permissions.includes("EconomicsItemUsage");
            },
        },
        methods: {
            loadAsyncData() {
                this.loading = true;
                axios.get("/economics/usage/", {
                    params: {
                        buyType: this.buyType,
                        sellType: this.sellType,
                        timegated: this.timegated,
                        inventory: this.ingredientId + ":" + this.ingredientAmount,
                        infiniteCurrencies: this.currencies.join(","),
                    }
                }).then(response =>
                {
                    this.acquisition = response.data;
                    this.error = "";
                    this.loaded = true;
                }).catch(error => {
                    this.acquisition = null;
                    this.error = error;
                }).finally(() => {
                    this.loading = false;
                })
            },
            clickCalculate() {
                this.loadAsyncData();
            },
        }
    }
</script>

<style scoped>

</style>